import {omit} from 'external/lodash'
import {React, FC, useContext, ComponentProps} from 'external/react'

import { TeacherContext } from 'teacher/context'
import Icon from 'components/icon'

type IconLinkProps = {
    label: string
    icon: string
} & ComponentProps<"a">

const IconLink : FC<IconLinkProps> = props => {
  const {icon, label} = props
  const {translate} = useContext(TeacherContext) as any
  return (
    <a {...omit(props, ['icon','label'])}>
      <Icon name={icon} />
      <label className="label">
        {translate(label)}
      </label>
    </a>
  )
}

export default IconLink